import HttpClient from './HttpClient';
import AppointmentService from './Appointment';
import UserService from './User';
import TimeSlotService from './TimeSlot';
import AdditionalInfoService from './AdditionalInfo';
import StatusService from './Status';
import StateService from './State';
import LanguageService from './Languages';

/* globals CSS_CONFIG */

export interface Services {
  appointment: AppointmentService;
  user: UserService;
  timeSlot: TimeSlotService;
  additionalInfo: AdditionalInfoService;
  status: StatusService;
  state: StateService;
  languages: LanguageService;
}

const configAppointmentService = (): AppointmentService => {
  const httpTW = new HttpClient(CSS_CONFIG.API);
  const httpBoka = new HttpClient(CSS_CONFIG.BOKAAPI);

  return new AppointmentService(httpTW, httpBoka);
};

const configUserService = (): UserService => {
  const http = new HttpClient(CSS_CONFIG.API);

  return new UserService(http);
};

const configTimeslotService = (): TimeSlotService => {
  const http = new HttpClient(CSS_CONFIG.API);

  return new TimeSlotService(http);
};

const configAdditionalInfoService = (): AdditionalInfoService => {
  const httpBoka = new HttpClient(CSS_CONFIG.BOKAAPI);

  return new AdditionalInfoService(httpBoka);
};

const configStatusService = (): StatusService => {
  const http = new HttpClient(CSS_CONFIG.API);

  return new StatusService(http);
};

const configStateService = (): StateService => {
  return new StateService();
};

const configLanguagesService = (): LanguageService => {
  const httpBoka = new HttpClient(CSS_CONFIG.BOKAAPI);
  return new LanguageService(httpBoka);
};

const configureServices = async (): Promise<Services> => {
  const appointment = configAppointmentService();
  const user = configUserService();
  const timeSlot = configTimeslotService();
  const additionalInfo = configAdditionalInfoService();
  const status = configStatusService();
  const state = configStateService();
  const languages = configLanguagesService();

  return {
    appointment,
    user,
    timeSlot,
    additionalInfo,
    status,
    state,
    languages,
  };
};

export default configureServices;
